module.exports = __webpack_public_path__ + "img/@logo_gore-tex@3x.b4e9a04e.png";